import React, { useState, useCallback, useContext, useReducer, useEffect } from 'react'
import { defaultReducer } from '../../Utils/reducers'
import { externalComponent } from '../../AppRoutes'
import { api } from '../../../services/api'
import { toast } from 'react-hot-toast'
import apptheme from '../../theme/default'
import { Box, TextField } from '@mui/material'
import ColorButton from '../../Buttons/ColorButton'
import SaveIcon from '@mui/icons-material/Save';
import IntegerOnly from '../../Utils/IntegerOnly'
import SendIcon from '@mui/icons-material/Send';
import EmailTestDialog from './EmailTestDialog'
import './styles.css'

const TlsButton = ({ children, tls, onClick }) => {
    return (
        <ColorButton
            fColor={tls ? apptheme.tertiaryColor : apptheme.secondaryColor}
            sColor={apptheme.primaryColor}
            onClick={onClick}>
            {children}
        </ColorButton>
    )
}

const Email = () => {

    const { setLoader } = useContext(externalComponent)

    const [showTestDialog, setShowTestDialog] = useState(false)

    const [state, setState] = useReducer(defaultReducer, {
        username: '',
        password: '',
        smtpserver: '',
        smtport: 0,
        smtpporttls: 0,
        tlson: false
    })

    const getEmail = useCallback(async () => {
        setLoader(true)
        const res = await api.get('/email/')
        setLoader(false)
        if (res.status === 200) {
            setState(res.data)
            return
        }
        toast.error('Ocorreu um erro ao encontrar os dados de email')

    }, [setLoader])

    useEffect(() => {
        getEmail()
    }, [getEmail])

    const saveData = useCallback(async () => {
        setLoader(true)
        const res = await api.patch(`/email/${state.id}/`, state)
        setLoader(false)
        if (res.status === 200) {
            setState(res.data)
            toast.success('Dados salvos com sucesso')
            return
        }
        toast.error('Ocorreu um erro ao salvar os dados')
    }, [setLoader, state])


    return (
        <>
        {showTestDialog && <EmailTestDialog object={state} handleClose={()=> {setShowTestDialog(false)}}/>}
            {state.id &&
                <>
                    <Box className='email-flex-header' >
                        <ColorButton
                            className='profile-save-button'
                            onClick={() => saveData(state)}
                            fColor={apptheme.tertiaryColor}
                            sColor={apptheme.primaryColor}>
                            <Box className='flexbox'><SaveIcon /> Salvar</Box>
                        </ColorButton>
                        <ColorButton
                            className='profile-save-button'
                            onClick={() => setShowTestDialog(true)}
                            fColor={apptheme.primaryColor}
                            sColor={apptheme.tertiaryColor}>
                            <Box className='flexbox'><SendIcon /> Testar</Box>
                        </ColorButton>
                    </Box>
                    <Box className='profile-overflow'>
                        <Box className='item-content-modal' >
                            <TextField
                                id="username"
                                type="text"
                                sx={{ backgroundColor: 'white' }}
                                label="Usuário"
                                value={state.username}
                                onChange={(e) => { setState({ 'username': e.target.value }) }}
                                fullWidth={false}
                                inputProps={{
                                    maxLength: 50
                                }}
                            />

                            <TextField
                                id="senha"
                                type="password"
                                sx={{ backgroundColor: 'white' }}
                                label="Senha"
                                value={state.password}
                                onChange={(e) => { setState({ 'password': e.target.value }) }}
                                fullWidth={false}
                                inputProps={{
                                    maxLength: 100
                                }}
                            />

                            <TextField
                                id="smtpserver"
                                type="text"
                                sx={{ backgroundColor: 'white' }}
                                label="Servidor"
                                value={state.smtpserver}
                                onChange={(e) => { setState({ 'smtpserver': e.target.value }) }}
                                fullWidth={false}
                                inputProps={{
                                    maxLength: 100
                                }}
                            />

                            <TextField
                                id="smtport"
                                type="text"
                                sx={{ backgroundColor: 'white' }}
                                label="Porta SMTP"
                                value={state.smtport}
                                onChange={(e) => { setState({ 'smtport': IntegerOnly(e.target.value, 0, 99999) }) }}
                                fullWidth={false}
                                inputProps={{
                                    maxLength: 5
                                }}
                            />

                            <TextField
                                id="smtpporttls"
                                type="text"
                                sx={{ backgroundColor: 'white' }}
                                label="Porta SMTP Caso TLS"
                                value={state.smtpporttls}
                                onChange={(e) => { setState({ 'smtpporttls': IntegerOnly(e.target.value, 0, 99999) }) }}
                                fullWidth={false}
                                inputProps={{
                                    maxLength: 5
                                }}
                            />

                            <Box className='email-tls-buttons'>
                                <TlsButton tls={!state.tlson} onClick={() => { setState({ tlson: false }) }}>Sem TLS</TlsButton>
                                <TlsButton tls={state.tlson} onClick={() => { setState({ tlson: true }) }} >TLS</TlsButton>
                            </Box>
                        </Box>
                    </Box>
                </>}
        </>
    )
}

export default Email